import { connect } from "react-redux";
import moment from "moment";

import InspectionSummary from "../Inspection/InspectionSummary";

const GrnLineBatchesAll = ({ data }) => (
  <div className="row row--gap-12">
    <div className="box-6">
      <div className="dashboard">
        <header className="dashboard__header dashboard__header--edit">
          <h2 className="dashboard__title heading">Logi</h2>
        </header>
        {data?.grn_line_batches?.length > 0 && (
          <ul className="logs-list">
            {data?.grn_line_batches
              .sort(
                (item, next) =>
                  new Date(next.confirmed_at).getTime() -
                  new Date(item.confirmed_at).getTime()
              )
              .map(
                ({
                  id,
                  confirmed_at,
                  quantity,
                  warehouse_position,
                  user,
                  product_sku,
                  product_name,
                }) => (
                  <li className="logs-list__item" key={id}>
                    <p className="title">
                      {moment(confirmed_at).format("DD.MM.YYYY HH:mm")}{" "}
                      {user?.full_name}
                    </p>
                    <p>
                      Migracja{" "}
                      <strong>
                        {quantity} szt. {product_name}[{product_sku}]
                      </strong>{" "}
                      na lokalizacji{" "}
                      <strong>{warehouse_position?.identifier}</strong>.
                    </p>
                  </li>
                )
              )}
          </ul>
        )}
      </div>
    </div>
    <InspectionSummary />
  </div>
);

export default connect(({ grn: { data } }) => ({
  data,
}))(GrnLineBatchesAll);
